<div class="mat-elevation-z8">
    <br />
    <form [formGroup]="VOForm">
        <ng-container formArrayName="VORows">
            <table
                #table
                mat-table
                [dataSource]="productDeliverable"
                class="mat-elevation-z8"
            >
                <!-- Position Column -->
                <ng-container matColumnDef="amount">
                    <th mat-header-cell *matHeaderCellDef>amount</th>
                    <td
                        mat-cell
                        *matCellDef="let element; let i = index"
                        [formGroup]="element"
                    >
                        @if (VOForm.get("VORows")?.value[i].isEditable) {
                            <span>
                                {{ VOForm.get("VORows")?.value[i].amount }}
                            </span>
                        }

                        @if (!VOForm.get("VORows")?.value[i].isEditable) {
                            <mat-form-field
                                style="width: 70%"
                                [appearance]="
                                    VOForm.get('VORows')?.value[i].isEditable
                                        ? 'fill'
                                        : 'outline'
                                "
                            >
                                <input
                                    matInput
                                    type="text"
                                    formControlName="amount"
                                    [readonly]="
                                        VOForm.get('VORows')?.value[i]
                                            .isEditable
                                    "
                                />
                            </mat-form-field>
                        }
                    </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="unit">
                    <th mat-header-cell *matHeaderCellDef>unit</th>
                    <td
                        mat-cell
                        *matCellDef="let element; let i = index"
                        [formGroup]="element"
                    >
                        @if (VOForm.get("VORows")?.value[i].isEditable) {
                            <span>
                                {{ VOForm.get("VORows")?.value[i].unit }}
                            </span>
                        }

                        @if (!VOForm.get("VORows")?.value[i].isEditable) {
                            <mat-form-field
                                style="width: 70%"
                                [appearance]="
                                    VOForm.get('VORows')?.value[i].isEditable
                                        ? 'fill'
                                        : 'outline'
                                "
                            >
                                <input
                                    matInput
                                    type="text"
                                    formControlName="unit"
                                    [readonly]="
                                        VOForm.get('VORows')?.value[i]
                                            .isEditable
                                    "
                                />
                            </mat-form-field>
                        }
                        <!-- </span> -->
                    </td>
                </ng-container>

                <!-- Name Column -->
                <ng-container matColumnDef="summary">
                    <th mat-header-cell *matHeaderCellDef>summary</th>
                    <td
                        mat-cell
                        *matCellDef="let element; let i = index"
                        [formGroup]="element"
                    >
                        @if (VOForm.get("VORows")?.value[i].isEditable) {
                            <span>
                                {{ VOForm.get("VORows")?.value[i].summary }}
                            </span>
                        }
                        @if (!VOForm.get("VORows")?.value[i].isEditable) {
                            <mat-form-field
                                style="width: 70%"
                                appearance="fill"
                            >
                                <input
                                    matInput
                                    type="text"
                                    formControlName="summary"
                                    [readonly]="
                                        VOForm.get('VORows')?.value[i]
                                            .isEditable
                                    "
                                />
                            </mat-form-field>
                        }
                        <!-- </span> -->
                    </td>
                </ng-container>

                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>Action</th>
                    <td
                        mat-cell
                        *matCellDef="let element; let i = index"
                        [formGroup]="element"
                    >
                        @if (!VOForm.get("VORows")?.value[i].isEditable) {
                            <button
                                mat-icon-button
                                class="material-icons app-toolbar-menu save-button"
                                matTooltip="Save Changes"
                                color="primary"
                                (click)="SaveVO(VOForm, i)"
                            >
                                <mat-icon>check_circle</mat-icon>
                            </button>
                        }

                        @if (!VOForm.get("VORows")?.value[i].isEditable) {
                            <button
                                mat-icon-button
                                class="material-icons app-toolbar-menu cancel-button"
                                matTooltip="Cancel Changes"
                                color="warn"
                                (click)="CancelSVO(VOForm, i)"
                            >
                                <mat-icon>cancel</mat-icon>
                            </button>
                        }

                        @if (VOForm.get("VORows")?.value[i].isEditable) {
                            <button
                                mat-icon-button
                                class="material-icons app-toolbar-menu save-button"
                                matTooltip="Edit"
                                color="primary"
                                (click)="EditSVO(VOForm, i)"
                            >
                                <mat-icon>edit</mat-icon>
                            </button>
                        }

                        @if (VOForm.get("VORows")?.value[i].isEditable) {
                            <button
                                mat-icon-button
                                class="material-icons app-toolbar-menu delete-button"
                                matTooltip="Delete"
                                color="warn"
                                (click)="Delete(VOForm, i)"
                            >
                                <mat-icon>delete</mat-icon>
                            </button>
                        }
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                    mat-row
                    *matRowDef="let row; columns: displayedColumns"
                ></tr>
            </table>
        </ng-container>
    </form>
</div>
